module.exports = __webpack_public_path__ + "static/img/led_difuso_branco_5mm-1.78376ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_branco_5mm-1.svg
// module id = 8DCm
// module chunks = 0